import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import { Typography } from '@mui/material';
import { Grid } from '@material-ui/core';
import { usageLog } from '../../store/actions/globalActions';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function AvisoDialog({
    open,
    handleClose,
    state
}) {
    const targetDate = new Date(2024, 4, 24, 23, 59, 0);
    const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
    const bloqued = new Date() > targetDate

    function calculateTimeRemaining() {
        const currentDate = new Date();
        const timeDifference = targetDate - currentDate;

        if (timeDifference > 0) {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            return { days, hours, minutes, seconds };
        } else {
            return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
    }

    // const companyId = JSON.parse(localStorage.companies)
    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeRemaining(calculateTimeRemaining());
        }, 1000);

        // Limpar o intervalo ao desmontar o componente
        return () => clearInterval(intervalId);
    }, []); // O array vazio assegura que o efeito só é executado uma vez (equivalente a componentDidMount)

    // const companyId = JSON.parse(localStorage.companies)
    const companyId = state?.company?.companies.find(company => company.companyCode == state.companyCode)
    return (
        <div>
            <Dialog
                open={open && state.companyCode}
                // open={true}
                onClose={() => {
                    usageLog("Funcionario/Inadimplente/Aviso/Fechou", companyId.id, null)
                    return bloqued ? null : handleClose()
                }}
                PaperProps={{
                    style: {
                        borderRadius: 20,
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: 'center' }}>
                    <WarningIcon style={{ width: '50px', height: '50px', color: '#feb52b' }} />
                    <Typography style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'montserrat', color: '#4650e6', marginTop: '-50px' }}>
                        <p style={{ marginBottom: '-50px' }}>Aviso</p>
                        <p>Importante</p>
                    </Typography>
                    <Typography style={{ textAlign: 'center', color: '#565655', fontWeight: 'bold', fontFamily: 'montserrat', marginTop: '-10px' }}>
                        {bloqued ? 'Seus registros foram bloqueados' : 'Seus registros serão bloqueados dia 24/5.'}
                    </Typography>
                </DialogTitle>
                <DialogContent style={{ marginTop: '-20px', overflow: 'hidden' }}>

                    <DialogContentText style={{ textAlign: 'center', color: '#565655' }}>
                        <Typography style={{ fontSize: '13px' }}>
                            Entre em contato com seu gestor imediatamente<br />
                            para continuar usando o Puntu e garantir<br />
                            que seus registros continuem sendo feitos<br />
                            de forma simples e prática.
                        </Typography>
                        {
                            bloqued ?
                                null
                                :
                                <>
                                    <Typography style={{ textAlign: 'center', color: '#f21616', fontWeight: 'bold', fontFamily: 'montserrat', marginTop: '20px' }}>
                                        Você não poderá mais registrar seu ponto em
                                    </Typography>

                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{
                                            marginTop: '1px',
                                            backgroundColor: "#c2222c",
                                            height: '78px',
                                            width: '415px',
                                            // marginLeft: '15px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-around',
                                            borderRadius: '15px'
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Typography variant="body1" style={{ fontSize: '40px', textAlign: 'center', fontWeight: "bold", color: 'white', fontFamily: 'montserrat' }}>
                                                {timeRemaining.days < 10 ? "0" + timeRemaining.days : timeRemaining.days}
                                            </Typography>
                                            <Typography variant="caption" style={{ fontSize: '11px', color: 'white', fontWeight: "bold", fontFamily: 'montserrat' }}>Dias</Typography>
                                        </div>
                                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '25px', marginTop: '-20px' }}>:</div>

                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Typography variant="body1" style={{ fontSize: '40px', textAlign: 'center', fontWeight: "bold", color: 'white', fontFamily: 'montserrat' }}>
                                                {timeRemaining.hours < 10 ? "0" + timeRemaining.hours : timeRemaining.hours}
                                            </Typography>
                                            <Typography variant="caption" style={{ fontSize: '11px', color: 'white', fontWeight: "bold", fontFamily: 'montserrat' }}>Horas</Typography>
                                        </div>
                                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '25px', marginTop: '-20px' }}>:</div>

                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Typography variant="body1" style={{ fontSize: '40px', textAlign: 'center', fontWeight: "bold", color: 'white', fontFamily: 'montserrat' }}>
                                                {timeRemaining.minutes < 10 ? "0" + timeRemaining.minutes : timeRemaining.minutes}
                                            </Typography>
                                            <Typography variant="caption" style={{ fontSize: '11px', color: 'white', fontWeight: "bold", fontFamily: 'montserrat' }}>Minutos</Typography>
                                        </div>
                                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '25px', marginTop: '-20px' }}>:</div>

                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Typography variant="body1" style={{ fontSize: '40px', textAlign: 'center', fontWeight: "bold", color: 'white', fontFamily: 'montserrat' }}>
                                                {timeRemaining.seconds < 10 ? "0" + timeRemaining.seconds : timeRemaining.seconds}
                                            </Typography>
                                            <Typography variant="caption" style={{ fontSize: '11px', color: 'white', fontWeight: "bold", fontFamily: 'montserrat' }}>Segundos</Typography>
                                        </div>
                                    </Grid>
                                </>
                        }
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button
                                style={{
                                    backgroundColor: '#00a000',
                                    color: 'white',
                                    borderRadius: '15px',
                                    width: '412px',
                                    height: '50px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    textTransform: 'none',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    padding: '-1px 50px',
                                    marginBottom: '-13px',
                                    marginTop: '10px'
                                }}
                                href={"https://api.whatsapp.com/send/?phone=5561996894936&text=gostaria%20de%20falar%20sobre%20meu%20acesso%20Premium!&type=phone_number&app_absent=0"}
                                onClick={() => { usageLog("Funcionario/Inadimplente/Aviso/WhatsApp", companyId.id, null) }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginLeft: '-21px' }}>
                                    FALE COM O SUPORTE
                                </div>
                                <div style={{ marginLeft: '17em', position: 'absolute', marginTop: '10px' }}>
                                    <WhatsAppIcon style={{ fontSize: '40px' }} />
                                </div>
                            </Button>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ flexDirection: 'column' }}>
                    {
                        bloqued ?
                            null :
                            <Button
                                onClick={() => {
                                    handleClose()
                                    usageLog("Funcionario/Inadimplente/Aviso/Fechou", companyId.id, null)
                                }}
                                style={{
                                    margin: '0 auto',
                                    borderRadius: '15px',
                                    border: '1px solid #555554',
                                    fontWeight: 'bold',
                                    backgroundColor: '#4651e6',
                                    color: 'white',
                                    width: '40%',  // Adicione esta linha para aumentar a largura do botão
                                }}
                            >
                                Fechar
                            </Button>
                    }
                </DialogActions>

            </Dialog>
        </div >
    );
}
